import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { GeneralResponse, Token } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { ICompleteStaffResponse } from "../../../types/apis/auth-apis";

export const CompleteStaff = async ({
    payload,
}: {
    payload: FormData;
}): Promise<GeneralResponse> => {
    try {
        const response = await Api<any, GeneralResponse<ICompleteStaffResponse>>({
            method: Methods.POST,
            endpoint: EndPoints.completeStaff,
            body: payload,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        handleApiResponseErrors(response, "validation_error");
        return response;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
};

export const useCompleteStaff = (options = {}) => {
    const mutation: UseMutationResult<
        GeneralResponse,
        Error,
        { payload: FormData }
    > = useMutation({
        mutationFn: CompleteStaff,
        ...options,
    });

    return {
        data: mutation.data,
        error: mutation.error,
        isError: mutation.isError,
        isSuccess: mutation.isSuccess,
        mutate: mutation.mutate,
        reset: mutation.reset,
        status: mutation.status,
    };
};
